import { render, staticRenderFns } from "./TprepSessionAdd.vue?vue&type=template&id=5e6048cf"
import script from "./TprepSessionAdd.vue?vue&type=script&lang=js"
export * from "./TprepSessionAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports